// extracted by mini-css-extract-plugin
export default {"timerConteiner":"Clok_timerConteiner__3hMWj","timer":"Clok_timer__PqsWe","clok":"Clok_clok__DEVbL"};